export default function PhoneString(phone) {
  if (phone) {
    return `(XX) XXXXX-${phone.substr(-4)}`;
  }
}
